/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-11-04T19:30:00+05:00
Intent: Count fields such as the Link-level timer take whole numbers only; a number input still lets "." and "e" be typed or pasted.
*/

const WHOLE_NUMBER = /^\d+$/;

// A number input still accepts "-", "+", "." and "e" (as in 1e3), so those keys are
// stopped before they reach it.
export function blockNonDigitKey(event: KeyboardEvent): void {
  if (['-', '+', '.', ',', 'e', 'E'].includes(event.key)) {
    event.preventDefault();
  }
}

export function blockNonDigitPaste(event: ClipboardEvent): void {
  const text = (event.clipboardData?.getData('text') || '').trim();
  if (!WHOLE_NUMBER.test(text)) {
    event.preventDefault();
  }
}
